<div>
    <app-page-breadcrumb pageTitle="Reporte de Guías de Remisión" />

    <!-- FILTROS -->
    <div
        class="mb-4 rounded-2xl border border-gray-200 bg-white px-5 py-5 dark:border-gray-800 dark:bg-white/[0.03]">

        <h3 class="mb-4 text-base font-semibold text-gray-800 dark:text-white/90">Filtros</h3>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">

            <app-date-picker id="startDate" label="Fecha inicio" placeholder="YYYY-MM-DD"
                [defaultDate]="startDate" (dateChange)="startDate = $event.dateStr">
            </app-date-picker>

            <app-date-picker id="endDate" label="Fecha fin" placeholder="YYYY-MM-DD"
                [defaultDate]="endDate" (dateChange)="endDate = $event.dateStr">
            </app-date-picker>

            <div>
                <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                    Destinatario (opcional)
                </label>
                @if (multiSelectVisible) {
                <app-multi-select [options]="clientOptions" [defaultSelected]="[]"
                    (selectionChange)="selectedClientIds = $event">
                </app-multi-select>
                }
            </div>

            <div>
                <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                    Motivo (opcional)
                </label>
                @if (multiSelectVisible) {
                <app-multi-select [options]="reasonOptions" [defaultSelected]="[]"
                    (selectionChange)="selectedReasonIds = $event">
                </app-multi-select>
                }
            </div>

            <div>
                <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">OT IDMH</label>
                <app-ot-input [(value)]="otNumber" placeholder="Buscar OT…"></app-ot-input>
            </div>

            <div>
                <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">Estado</label>
                <select [(ngModel)]="status"
                    class="h-11 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
                    @for (opt of statusOptions; track opt.value) {
                    <option [value]="opt.value">{{ opt.label }}</option>
                    }
                </select>
            </div>

        </div>

        <!-- Botones acción -->
        <div class="mt-4 flex items-center gap-3">
            <button type="button"
                class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                (click)="onFilter()" [disabled]="loading">
                @if (loading) {
                <svg class="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="white" stroke-width="3"
                        stroke-dasharray="31.4 31.4" stroke-linecap="round" />
                </svg>
                Filtrando…
                } @else {
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
                </svg>
                Filtrar
                }
            </button>

            <button type="button"
                class="inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
                (click)="onClearFilters()" [disabled]="loading">
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                Limpiar filtros
            </button>

            @if (hasSearched && rows.length > 0) {
            <button type="button"
                class="ml-auto inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                (click)="exportToExcel()" [disabled]="isExporting">
                @if (isExporting) {
                <svg class="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="white" stroke-width="3"
                        stroke-dasharray="31.4 31.4" stroke-linecap="round" />
                </svg>
                Exportando…
                } @else {
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                </svg>
                Exportar Excel
                }
            </button>
            }
        </div>

    </div>

    <!-- TABLA -->
    <div
        class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/3 xl:px-4 xl:py-5">
        <div class="w-full">
            <div
                class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/5 dark:bg-white/3">

                <div
                    class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                    <div>
                        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Listado de guías</h3>
                        @if (reportMeta) {
                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                            {{ reportMeta.companyName }} &mdash; {{ reportMeta.dateRange }} &mdash;
                            <span class="font-medium">{{ reportMeta.totalItems }} guías</span>
                        </p>
                        }
                    </div>

                    <input type="text" placeholder="Buscar en resultados..."
                        (input)="setSearchTerm($any($event.target).value)"
                        class="h-10.5 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 xl:w-75" />
                </div>

                <div class="overflow-hidden">
                    <div class="max-w-full px-5 overflow-x-auto sm:px-6">

                        <table class="w-full min-w-270">
                            <thead class="border-y border-gray-100 dark:border-white/5">
                                <tr>
                                    <th class="w-[8%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Fecha</th>
                                    <th class="w-[10%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200"
                                            (click)="toggleSort('guia')">
                                            Guía
                                            <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'guia'"
                                                fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                                @if (sortColumn === 'guia' && sortDir === 'asc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                                } @else if (sortColumn === 'guia' && sortDir === 'desc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                                } @else {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                                                }
                                            </svg>
                                        </button>
                                    </th>
                                    <th class="w-[8%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200"
                                            (click)="toggleSort('ot')">
                                            OT IDMH
                                            <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'ot'"
                                                fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                                @if (sortColumn === 'ot' && sortDir === 'asc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                                } @else if (sortColumn === 'ot' && sortDir === 'desc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                                } @else {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                                                }
                                            </svg>
                                        </button>
                                    </th>
                                    <th class="w-[18%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200"
                                            (click)="toggleSort('cliente')">
                                            Destinatario
                                            <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'cliente'"
                                                fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                                @if (sortColumn === 'cliente' && sortDir === 'asc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                                } @else if (sortColumn === 'cliente' && sortDir === 'desc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                                } @else {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                                                }
                                            </svg>
                                        </button>
                                    </th>
                                    <th class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Motivo</th>
                                    <th class="w-[14%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Punto de partida</th>
                                    <th class="w-[14%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Punto de llegada</th>
                                    <th class="w-[6%] py-3 font-normal text-gray-500 text-center text-theme-sm dark:text-gray-400">Peso</th>
                                    <th class="w-[9%] py-3 font-normal text-gray-500 text-center text-theme-sm dark:text-gray-400">Estado</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 dark:divide-white/5">
                                @if (loading) {
                                <tr><td colspan="9" class="py-16 text-center text-gray-400">Cargando…</td></tr>
                                } @else if (!hasSearched) {
                                <tr><td colspan="9" class="py-16 text-center text-gray-400 text-sm">Selecciona el rango de fechas y pulsa «Filtrar».</td></tr>
                                } @else if (currentItems.length === 0) {
                                <tr><td colspan="9" class="py-16 text-center text-gray-400 text-sm">Sin resultados para los filtros aplicados.</td></tr>
                                } @else {
                                @for (row of currentItems; track $index) {
                                <tr class="hover:bg-gray-50 dark:hover:bg-white/2 transition-colors">
                                    <td class="py-3 text-gray-600 text-theme-sm dark:text-gray-400 whitespace-nowrap">{{ row.issueDate }}</td>
                                    <td class="py-3 text-gray-800 text-theme-sm dark:text-white/90 font-medium whitespace-nowrap">{{ row.guide }}</td>
                                    <td class="py-3 text-gray-600 text-theme-sm dark:text-gray-400 whitespace-nowrap">{{ row.otNumber || '—' }}</td>
                                    <td class="py-3 pr-3 text-gray-700 text-theme-sm dark:text-gray-300">{{ row.client }}</td>
                                    <td class="py-3 pr-3 text-gray-600 text-theme-sm dark:text-gray-400">{{ row.transferReasonName ?? '—' }}</td>
                                    <td class="py-3 pr-3 text-gray-600 text-theme-sm dark:text-gray-400">
                                        {{ originLabel(row) }}
                                        @if (row.originName) {
                                        <span class="block text-xs text-gray-400">{{ row.originAddress }}</span>
                                        }
                                    </td>
                                    <td class="py-3 pr-3 text-gray-600 text-theme-sm dark:text-gray-400">{{ row.destinationAddress || '—' }}</td>
                                    <td class="py-3 text-center text-gray-600 text-theme-sm dark:text-gray-400">
                                        {{ row.grossWeight != null ? (row.grossWeight | number:'1.2-2') : '—' }}
                                    </td>
                                    <td class="py-3 text-center">
                                        <span class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap"
                                            [ngClass]="statusClass(row.status)">{{ row.status }}</span>
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>

                    </div>
                </div>

                <!-- PAGINACIÓN -->
                <div class="px-6 py-4 border-t border-gray-200 dark:border-white/5">
                    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div class="flex items-center gap-2">
                            <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
                            <select
                                class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
                                (change)="onPageSizeChange(+$any($event.target).value)">
                                @for (opt of pageSizeOptions; track opt) {
                                <option [value]="opt" [selected]="opt === pageSize">{{ opt }}</option>
                                }
                            </select>
                            <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
                        </div>
                        <div class="flex items-center justify-between sm:justify-end gap-2">
                            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage - 1)"
                                [disabled]="currentPage === 1">
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.58301 9.99868C2.58272 10.1909 2.65588 10.3833 2.80249 10.53L7.79915 15.5301C8.09194 15.8231 8.56682 15.8233 8.85981 15.5305C9.15281 15.2377 9.15297 14.7629 8.86018 14.4699L5.14009 10.7472L16.6675 10.7472C17.0817 10.7472 17.4175 10.4114 17.4175 9.99715C17.4175 9.58294 17.0817 9.24715 16.6675 9.24715L5.14554 9.24715L8.86017 5.53016C9.15297 5.23717 9.15282 4.7623 8.85983 4.4695C8.56684 4.1767 8.09197 4.17685 7.79917 4.46984L2.84167 9.43049C2.68321 9.568 2.58301 9.77087 2.58301 9.99715C2.58301 9.99766 2.58301 9.99817 2.58301 9.99868Z"
                                        fill=""></path>
                                </svg>
                                <span class="hidden sm:inline">Anterior</span>
                            </app-button>
                            <span class="block text-sm font-medium text-gray-700 dark:text-gray-400 sm:hidden">
                                Pág. {{ currentPage }} / {{ totalPages }}
                            </span>
                            <ul class="hidden items-center gap-0.5 sm:flex">
                @for (item of pageItems; track $index) {
                <li>
                  @if (item === '...') {
                  <span class="flex h-10 w-8 items-center justify-center text-sm text-gray-400 select-none">…</span>
                  } @else {
                  <button (click)="goToPage(item)"
                    class="flex h-10 w-10 items-center justify-center rounded-lg text-theme-sm font-medium" [ngClass]="{
                      'bg-brand-500 text-white': currentPage === item,
                      'text-gray-700 hover:bg-brand-500/8 dark:hover:bg-brand-500 dark:hover:text-white hover:text-brand-500 dark:text-gray-400': currentPage !== item
                    }">
                    {{ item }}
                  </button>
                  }
                </li>
                }
              </ul>
                            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage + 1)"
                                [disabled]="currentPage === totalPages">
                                <span class="hidden sm:inline">Siguiente</span>
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M17.4175 9.9986C17.4178 10.1909 17.3446 10.3832 17.198 10.53L12.2013 15.5301C11.9085 15.8231 11.4337 15.8233 11.1407 15.5305C10.8477 15.2377 10.8475 14.7629 11.1403 14.4699L14.8604 10.7472L3.33301 10.7472C2.91879 10.7472 2.58301 10.4114 2.58301 9.99715C2.58301 9.58294 2.91879 9.24715 3.33301 9.24715L14.8549 9.24715L11.1403 5.53016C10.8475 5.23717 10.8477 4.7623 11.1407 4.4695C11.4336 4.1767 11.9085 4.17685 12.2013 4.46984L17.1588 9.43049C17.3173 9.568 17.4175 9.77087 17.4175 9.99715C17.4175 9.99763 17.4175 9.99812 17.4175 9.9986Z"
                                        fill=""></path>
                                </svg>
                            </app-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
